const hasSymbol=typeof Symbol==='function'&&Symbol.for;export default hasSymbol?Symbol.for('mui.nested'):'__THEME_NESTED__';